<template>
  <div v-loading="loading">
    <pt-page-title :title="`${title}样品`">
      <el-button slot="on-right" type="primary" plain @click="goExcel" v-if="!isEdit">上传EXCEL模板创建
      </el-button>
    </pt-page-title>
    <pt-lab-order-form class="pt-lab-order-form__withData" ref="form" :value="currentForm" :bill="bill" :isEdit="isEdit" :recollect="recollect"></pt-lab-order-form>
    <div class="button-div">
      <el-button type="primary" @click="save">提交</el-button>
      <el-button type="primary" plain @click="cancel">取消</el-button>
    </div>
  </div>
</template>

<script>
import {
  getReportSignature
} from '@/utils/formUtils'
import PtLabOrderFrom from './index'
// import { handleWorkFlow } from './form-required-option'
export default {
  name: 'pt-lab-order-form__withData',
  components: {
    'pt-lab-order-form': PtLabOrderFrom
  },
  computed: {
    form () {
      return this.$refs.form
    },
    isEdit () {
      return this.$route.params.isEdit !== 'false'
    },
    disabled () {
      return this.isEdit && this.currentForm.nextOrderAction !== 'LAB_SAMPLES_RECEIVED'
    },
    recollect () {
      return this.$route.query.recollect === 'true'
    },
    title () {
      if (this.recollect) {
        return '创建重采'
      }
      return this.isEdit ? '编辑' : '新建'
    },
    focusView () {
      return this.$store.state.saasConfig.focusView
    },
    isContractFunction () {
      return this.$store.state.saasConfig.openContract
    }
  },
  data () {
    return {
      loading: false,
      bill: null,
      currentForm: {},
      signatureInfo: {},
      workflow: ''
    }
  },
  methods: {
    changeData (val) {
      if (val) {
        val.reportSignature = val.reportSignature || val.re ? '有' : '无'
        if (val.signatures[0]) {
          val.reportSignatureOne = getReportSignature(val.signatures[0].signature, val.signatures[0].name)
        }
        if (val.signatures[1]) {
          val.reportSignatureTwo = getReportSignature(val.signatures[1].signature, val.signatures[1].name)
        }
        if (val.signatures[2]) {
          val.reportSignatureThree = getReportSignature(val.signatures[2].signature, val.signatures[2].name)
        }
        return val
      }
    },
    goLotNew () {
      this.$router.push('/business-order-lot-new')
    },
    load (id) {
      this.loading = true
      this.$store.dispatch('getLabOrderDetail', id).then((response) => {
        this.loading = false
        response.order.attachments = response.order.attachments?.filter(e => e.type === 'LITERATURE') || []
        this.currentForm = response.order
        this.bill = response.bill
      }).catch((error) => {
        this.loading = false
        this.$message.error(error || '获取订单信息失败！')
      })
    },
    formatToAjax (form) {
      let copyData = JSON.parse(JSON.stringify(form))

      copyData.reportNum = Number(copyData.reportNum)
      copyData.urgentMoney = Number(copyData.urgentMoney)
      copyData.billAmount = Number(copyData.billAmount)

      if (copyData.attachments?.length) {
        copyData.attachments = copyData.attachments.map(item => {
          return {
            type: 'LITERATURE',
            name: item.name,
            ossUrl: item.response
          }
        })
      }
      return copyData
    },
    save () {
      this.form.validate('form').then(form => {
        this.loading = true
				// form.pack=form.pack_show.join()
				form.storage=form.storage_show.join()
        !this.isEdit || this.recollect ? this.create(this.formatToAjax(form)) : this.edit(this.formatToAjax(form))
        // !this.isEdit || this.recollect ? this.create(form) : this.edit(form)
      })
    },
    cancel () {
      history.go(-1)
    },
    edit (formValue) {
      console.log(formValue)
      this.$store.dispatch('editLabOrder', formValue).then(data => {
        // console.error('==========', data)
        this.loading = false
        this.$message.success('保存成功！')
        this.cancel()
      }).catch(errorMessage => {
        // console.error('==========', errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    },
    create (formValue) {
      const api = this.recollect ? 'creatRecollectLabOrder' : 'creatLabOrder'
      this.$store.dispatch(api, formValue).then(data => {
        // console.error('==========', data)
        this.loading = false
        this.$message.success('创建成功！')
        this.cancel()
      }).catch(errorMessage => {
        // console.error('==========', errorMessage)
        console.error(errorMessage)
        this.loading = false
        this.$message.error(errorMessage)
      })
    },
    goExcel () {
      this.$router.push('/batch-add-lab-order')
    }
  },
  created () {
    if (this.isEdit) {
      this.load(this.$route.params.id)
    }
  }
}
</script>
<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.created-button{
  margin-left: 40PX;
}
</style>
